class SizeGuide extends HTMLElement {
  constructor() {
    super();
    const form = this.querySelector("form");
    form.addEventListener("change", this.handleChange.bind(this));

    const opener = document.querySelector(".size-guide-modal-opener button");
    opener.addEventListener("click", this.handleOpen.bind(this));

    const closer = document.querySelector(
      ".size-guide-modal__title-bar button"
    );
    closer.addEventListener("click", this.handleClose.bind(this));

    this.container = this.querySelector(".size-guide-modal");

    this.sizeGuideData = {
        XS: {
            US: "0-2",
            bust: '32.6"',
            waist: '25.2"',
            hip: '35.6"',
        },
        S: {
            US: "4-6",
            bust: '34.64"',
            waist: '27.2"',
            hip: '37.6"',
        },
        M: {
            US: "8-10",
            bust: '36.6"',
            waist: '29.1"',
            hip: '39.6"',
        },
        L: {
            US: "12-14",
            bust: '38.5"',
            waist: '31.1"',
            hip: '41.5"',
        },
        XL: {
            US: "14-16",
            bust: '40.5"',
            waist: '33.1"',
            hip: '43.5"',
        },
        "1X": {
            US: "16-18",
            bust: '43.5"',
            waist: '36"',
            hip: '46.5"',
        },
        "2X": {
            US: "18-20",
            bust: '46.4"',
            waist: '39"',
            hip: '49.4"',
        },
        "3X": {
            US: "20-22",
            bust: '49.4"',
            waist: '41.9"',
            hip: '52.4"',
        },
        };
  }

  handleOpen() {
    this.container.classList.add("size-guide-modal--active");
  }

  handleClose() {
    this.container.classList.remove("size-guide-modal--active");
  }

  handleChange(evt) {
    const size = evt.target.value;
    const sizeInfo = this.sizeGuideData[size];
    this.querySelector(
      ".size-headline"
    ).textContent = `${size} (${sizeInfo.US})`;
    this.querySelectorAll(".bust").forEach((item) => {
      item.textContent = sizeInfo.bust;
    });
    this.querySelectorAll(".waist").forEach((item) => {
      item.textContent = sizeInfo.waist;
    });
    this.querySelectorAll(".hip").forEach((item) => {
      item.textContent = sizeInfo.hip;
    });
  }
}

customElements.define("size-guide", SizeGuide);
